import { decryptData } from "./cryptoUtils";

export const getToken = (): string | null => {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
};

// Utility function to get refresh token
export const getRefreshToken = (): string | null => {
  return localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken");
};

// Utility function to get facility ID
export const getFacilityId = (): string | null => {
  return localStorage.getItem("facilityId") || sessionStorage.getItem("facilityId");
};

// export const getLoginUserData = (): string | null => {
//   return (
//     localStorage.getItem("loginUserData") ||
//     sessionStorage.getItem("loginUserData")
//   );
// };

export const getLoginUserId = (): any => {
  return (
    localStorage.getItem("loginUserId") || sessionStorage.getItem("loginUserId")
  );
};

export const getUserLoginData = (): string | null => {
  return (
    localStorage.getItem("userLoginData") ||
    sessionStorage.getItem("userLoginData")
  );
};

// SuperAdmin who also has provider (both-portal) access — eligible to broadcast chat messages
export const canBroadcastMessage = (): boolean => {
  try {
    const parseLoginUserData: any = getLoginUserData();
    const userData = JSON.parse(parseLoginUserData);
    return (
      userData?.roleNames?.includes("SuperAdmin") === true &&
      userData?.customAttributes?.isAdminAccess === "true"
    );
  } catch (error) {
    return false;
  }
};

export const getUserPermission = () => {
  try {
    const data: any =
    localStorage.getItem("userPermission") ||
    sessionStorage.getItem("userPermission");    
    if (!data) return null;

    const parsed = JSON.parse(data);

    if (parsed?.patient || parsed?.visit || parsed?.task) {
      return parsed;
    }

    if (parsed?.permission) {
      return parsed.permission;
    }

    return null;
  } catch (error) {
    console.error("Error parsing user permission:", error);
    return null;
  }
};

export const getFacilityStatus = (): string | null => {
  const data: any =
    localStorage.getItem("facilityStatus") ||
    sessionStorage.getItem("facilityStatus");
  return JSON.parse(data);
};

export const getLoginUserData = (): string | null => {
  const encryptedData =
    localStorage.getItem("loginUserData") ||
    sessionStorage.getItem("loginUserData");
  if (!encryptedData) return null;

  try {
    const decryptedData = decryptData(encryptedData); // Decrypt first
    if (!decryptedData) return null;

    return JSON.parse(decryptedData); // Parse the decrypted JSON string
  } catch (error) {
    console.error("Error decrypting login data:", error);
    return null;
  }
};

/**
 * Gets facilities data from storage
 */
export const getFacilities = (): any[] | null => {
  try {
    const facilitiesData = localStorage.getItem("facilities") || sessionStorage.getItem("facilities");
    if (!facilitiesData) return null;
    return JSON.parse(facilitiesData);
  } catch (error) {
    console.error("Error getting facilities data:", error);
    return null;
  }
};

/**
 * Checks if the user should see the "Switch to Provider" button
 * Returns true if user has admin access and facilities are available
 */
export const shouldShowSwitchToProvider = (): boolean => {
  const userDataString = getLoginUserData();
  const facilities = getFacilities();
  
  if (!userDataString || !facilities) return false;
  
  try {
    const userData = JSON.parse(userDataString);
    
    const isAdminAccess = userData?.customAttributes?.isAdminAccess;
    const hasFacilities = facilities && facilities.length > 0;
    
    return isAdminAccess === "true" && hasFacilities;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return false;
  }
};
